import React from "react";
import { Box, Text, VStack } from "@chakra-ui/react";
import { AddPaypalButton, offerPaypal } from "components/Paypal";
// import AddPlaidACHButton from "containers/Pages/PlaidACH/AddPlaidACHButton"; // leaving here in case we bring back
import { useSessionCtx } from "utils";
import { AddCCButton, CancelButton } from "../common";

export default function AddPaymentMethodButtons({
  title = "Add a payment method to your account",
  chooserConfig = {},
  allowedProviders = {},
  onCancel,
}) {
  const {
    debug,
    sessionCtx: { flowConfig },
  } = useSessionCtx();
  const includeAddPaypal = offerPaypal(chooserConfig, flowConfig, debug);
  const includeAddCreditCard = chooserConfig.addCC || false;
  // const includeAddACH = chooserConfig.addACH || false;

  // We need to check the allowed providers info we get back from /transaction-methods api endpoint to see if we can use a credit card or paypal.
  // If 'card' or 'paypal' is not included in array, then that currently only means that the purchase amount exceeds the maximum.
  // TODO: This is a very fragile way for determining the reason we should not allow the user to add a credit card or paypal.  Better would be for the endpoint to return a code and/or message for why we don't want them to add cc/paypal
  let ccAmountExceedsMax = false;
  let paypalAmountExceedsMax = false;
  if (allowedProviders && allowedProviders.purchase) {
    ccAmountExceedsMax = !allowedProviders.purchase.includes("card");
    paypalAmountExceedsMax = !allowedProviders.purchase.includes("paypal");
  }

  return (
    <Box mb={4}>
      <Box mb={2}>
        <Text>{title}</Text>
      </Box>

      <VStack spacing={2} align="stretch">
        {includeAddPaypal && <AddPaypalButton amountExceedsMax={paypalAmountExceedsMax} />}
        {/* {includeAddACH && <AddPlaidACHButton />} // leaving here in case we bring back */}
        {includeAddCreditCard && <AddCCButton amountExceedsMax={ccAmountExceedsMax} />}
        {onCancel && <CancelButton onClick={onCancel} />}
      </VStack>
    </Box>
  );
}
